import React from 'react';
import { s } from '../Style.jsx';

const Menu = ({ setScreen, screen, vendor }) => {

    return <>
        <nav>
            <button style={s.tabButton(screen === "Orders")} onClick={() => setScreen("Orders")}>{vendor.name}</button>
            {vendor.enableMenus && <>
                <button style={s.tabButton(screen === "EditMenu")} onClick={() => setScreen("EditMenu")}>Edit Menu</button>
                <button style={s.tabButton(screen === "Business Hours")} onClick={() => setScreen("Business Hours")}>Business Hours</button>
            </>}
        </nav>
    </>;
}
export default Menu;